import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import { getConsolidationDataByType } from '@/features/dashboard/api/getConsolidationDataByType.ts';
import { TypesConsolidationData } from '@/types/ConsolidationData.ts';

type QueryFnType = typeof getConsolidationDataByType;

function useConsolidationPedagogicalHistorya(year?: number) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-pedagogical-history', year],
    queryFn: () => getConsolidationDataByType(TypesConsolidationData.SCORE_PEDAGOGICO_ALUNOS, year ? String(year) : undefined),
  });
}

export { useConsolidationPedagogicalHistorya };
